import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useMenuStyles } from './Menu.styles'
import MenuItem from './MenuItem'
import menuConfig from './menu.config'
import MenuToggleIcon from '../icons/MenuToggleIcon'

type BaseProps = {
    onToggleMenu: (open: boolean) => void
    selectedSubmenu: string
    setSelectedSubmenu: (submenu: string) => void
}

const tabletBreakPoint = 1000

export const Menu: React.FC<BaseProps> = ({
    onToggleMenu,
    selectedSubmenu,
    setSelectedSubmenu
}) => {
    const styles = useMenuStyles()
    const [isMenuOpen, setIsMenuOpen] = useState(true)
    const [isTabletView, setIsTabletView] = useState(false)
    const { pathname } = useLocation()
    const params = useParams()
    const patientId = useMemo(() => Number(params.patientId), [params])
    const reportId = useMemo(() => Number(params.reportId), [params])

    const menuStateClass = isMenuOpen ? 'open' : ''

    const toggleMenu = () => {
        const isMenuOpenNewValue = !isMenuOpen
        setIsMenuOpen(isMenuOpenNewValue)
        onToggleMenu(isMenuOpenNewValue)
    }

    const updateWindowDimensions = useCallback(() => {
        const isTabletViewByWindowDimensions =
            window.innerWidth < tabletBreakPoint
        setIsTabletView(isTabletViewByWindowDimensions)

        if (isTabletViewByWindowDimensions) {
            setIsMenuOpen(false)
            onToggleMenu(false)
        }
    }, [onToggleMenu])

    useEffect(() => {
        window.addEventListener('resize', updateWindowDimensions)

        return () => {
            window.removeEventListener('resize', updateWindowDimensions)
        }
    }, [updateWindowDimensions, patientId, reportId])

    return (
        <div className={`${styles.menu} ${isTabletView ? '' : menuStateClass}`}>
            {!isTabletView && (
                <div className={styles.toggleBox} onClick={toggleMenu}>
                    <MenuToggleIcon
                        className={`${styles.toggleButton} ${
                            isMenuOpen ? 'open' : ''
                        }`}
                    />
                    {isMenuOpen && (
                        <div className={styles.text}>Collapse menu</div>
                    )}
                </div>
            )}
            {menuConfig.map((menuItem) => {
                return (
                    menuItem.show && (
                        <MenuItem
                            name={menuItem.name}
                            isMenuOpen={isMenuOpen}
                            isTabletView={isTabletView}
                            iconSrc={menuItem.iconSrc}
                            route={menuItem.route}
                            subMenu={menuItem.subMenu}
                            key={menuItem.name}
                            isActive={pathname === menuItem.route}
                            selectedSubmenu={selectedSubmenu}
                            setSelectedSubmenu={setSelectedSubmenu}
                        />
                    )
                )
            })}
        </div>
    )
}

export default Menu
